import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    storageKey: String
  }

  connect() {
    if (localStorage.getItem(this.storageKeyValue) != 1) this.show()
  }

  show() {
    this.element.classList.remove("!hidden")
  }

  hide() {
    localStorage.setItem(this.storageKeyValue, 1)
    this.element.classList.add("!hidden")
  }
}
